import React, { useEffect, useRef } from 'react';
import styles from './styles.module.css';

export default function SelectedMessage({
  showSelectBox,
  setShowSelectBox,
  selectedMessage,
  setSelectedMessage,
  selectedBoxPosition,
  onClickSelect,
}) {
  const ref = useRef();
  const checkIfClickedOutside = (e) => {
    // If the menu is open and the clicked target is not within the menu,
    // then close the menu
    if (showSelectBox && ref.current && !ref.current.contains(e.target)) {
      setShowSelectBox(false);
      console.log('firstdepen');
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [showSelectBox]);

  console.log('selectedBoxPosition==', selectedBoxPosition);
  return (
    <div
      className={`${styles.container} themeBox `}
      style={{
        top: selectedBoxPosition?.y + 'px',
        left: selectedBoxPosition?.x + 'px',
      }}
      ref={ref}
      onClick={onClickSelect}
    >
      select
    </div>
  );
}
